export default __webpack_public_path__ + "static/blog7-97f9e205d350b574f8c5783c09a8f809.jpg";